import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const HeartOutlineIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M7.76475 3.75C5.01271 3.75 2.75 5.97254 2.75 8.73948C2.75 10.3807 3.24007 11.7071 4.54619 13.2732C5.82112 14.8019 7.90076 16.5913 11.0971 19.1809L11.75 19.75L12.4029 19.1809C15.5992 16.5913 17.6789 14.8019 18.9538 13.2732C20.2599 11.7071 20.75 10.3807 20.75 8.73948C20.75 6.01357 18.5285 3.75 15.7352 3.75C13.8029 3.75 12.57 4.68058 11.75 5.51556C10.93 4.68058 9.69714 3.75 7.76475 3.75ZM4.80903 8.73948C4.80903 7.1118 6.14638 5.78846 7.76475 5.78846C9.24803 5.78846 10.0487 6.64828 10.7895 7.4917L10.7907 7.49305L11.75 8.57618L12.7096 7.49271L12.7109 7.49129C13.4516 6.64787 14.252 5.78846 15.7352 5.78846C17.3536 5.78846 18.691 7.1118 18.691 8.73948C18.691 9.86248 18.3523 10.8017 17.2767 12.0677C16.2205 13.3108 14.4911 14.825 11.75 17.0729C9.00891 14.825 7.27945 13.3108 6.22328 12.0677C5.14773 10.8017 4.80903 9.86248 4.80903 8.73948Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
